import React from 'react';
import { Shield, ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="w-full bg-white py-12 px-4 sm:py-16 sm:px-6 md:py-28" data-id="element-169">
      <div className="max-w-4xl mx-auto" data-id="element-170">
        {/* Transformation */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20" data-id="element-171">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#4C1D95] mb-4 sm:mb-6" data-id="element-172">
            Lo que vas a sentir cuando lo apliques
          </h2>
          <p className="text-base sm:text-xl text-[#555555] mb-6 sm:mb-8" data-id="element-173">
            No "motivación". Vas a sentir algo más raro y más valioso:
          </p>
          <h3 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-[#84CC16] mb-6 sm:mb-8 tracking-tight" data-id="element-174">
            calma.
          </h3>
          <p className="text-base sm:text-lg text-[#444444] max-w-2xl mx-auto" data-id="element-175">
            Porque por fin tienes un criterio para decidir qué hacer hoy, cuánto
            hacer, y cómo saber si funcionó.
          </p>
        </div>

        {/* Offer Card */}
        <div className="bg-[#4C1D95] text-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-176">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-[#7C3AED]/20 rounded-full -mr-20 -mt-20 blur-3xl" data-id="element-177"></div>
          <div className="absolute bottom-0 left-0 w-48 sm:w-64 h-48 sm:h-64 bg-[#84CC16]/10 rounded-full -ml-20 -mb-20 blur-3xl" data-id="element-178"></div>

          <div className="relative z-10 flex flex-col items-center text-center md:flex-row md:items-center md:justify-between md:text-left gap-8 sm:gap-10" data-id="element-179">
            <div className="flex-1" data-id="element-180">
              <h3 className="text-2xl sm:text-3xl font-serif font-bold mb-2" data-id="element-181">
                Sanar en Movimiento
              </h3>
              <p className="text-[#A3E635] text-base sm:text-lg mb-4 sm:mb-6" data-id="element-182">
                Ebook + Checklists + Plantillas
              </p>

              <div className="flex items-center justify-center md:justify-start gap-3 mb-6 sm:mb-8" data-id="element-183">
                <span className="text-4xl sm:text-5xl font-bold text-white" data-id="element-184">
                  $7.29
                </span>
                <span className="text-xs sm:text-sm text-purple-300 uppercase tracking-wide text-left" data-id="element-185">
                  Pago
                  <br data-id="element-186" />
                  Único
                </span>
              </div>

              <div className="flex items-start gap-3 bg-[#5B21B6] p-3 sm:p-4 rounded-lg border border-[#7C3AED]" data-id="element-187">
                <Shield className="w-5 h-5 text-[#A3E635] flex-shrink-0 mt-0.5" data-id="element-188" />
                <p className="text-xs sm:text-sm text-purple-200 text-left" data-id="element-189">
                  <span className="text-white font-bold" data-id="element-190">
                    Garantía de 7 días:
                  </span>{' '}
                  si lo lees y no te da un marco claro para moverte con más
                  seguridad, lo devuelves.
                </p>
              </div>
            </div>

            <div className="w-full md:w-auto" data-id="element-191">
              <a href="https://mindmeetsmovement.com/cart/47324808413414:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-[#84CC16] hover:bg-[#65A30D] active:scale-[0.98] text-[#1a1a1a] text-lg sm:text-xl font-bold rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center group" data-id="element-192">
                Empieza hoy
                <ArrowRight className="ml-2 w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" data-id="element-193" />
              </a>
              <p className="mt-3 sm:mt-4 text-xs text-center text-purple-300" data-id="element-194">
                Acceso inmediato a la descarga digital
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8 sm:mt-12" data-id="element-195">
          <p className="text-sm sm:text-base text-[#555555] italic" data-id="element-196">
            No para "arreglarte en 24 horas". <br data-id="element-197" />
            Para dejar de perder semanas por falta de sistema.
          </p>
        </div>
      </div>
    </section>;
}